module.exports = __webpack_public_path__ + "img/goodtalent.cfa71042.png";